<template>
    <div class="portal-jzlpage-container" v-if="inited">
        <jzl-form-web v-if="isValidForm"
                      :form-code="formCode" :view-code="viewCode" :form-id="formId" :view-id="viewId" :menu-id="menuId" :data-id="dataId"
                      @ready="handlePageReady"></jzl-form-web>
        <page-404 v-else></page-404>
    </div>
</template>

<script>
    import common from '../../utils/common';
    import PageCommon from './PageCommon';

    export default {
        extends: PageCommon,
        data() {
            return {
                inited: false,
                dataId: null,
                pageTitle: "数据新增"
            }
        },
        components: {},
        mounted () {
            this.init();
        },
        computed: {
            isMainMenu() {
                return common.isMainMenu('fadd', this.formCode, this.viewCode)
            }
        },
        watch: {
            '$route' (to, from) {
                this.init();
            },
        },
        methods: {
            async init() {
                this.dataId = this.$route.query._id;
                this.inited = true;
            }
        }
    }
</script>
